import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MainService {

  constructor(
    public http: HttpClient
  ) {


  }
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {


    return new Promise<void>((resolve, reject) => {
      Promise.all([this.loadPermission(), this.doGetSchoolInFo()]).then(() => {
        resolve();
      }, reject);
    });
  }
  doGetSchoolInFo() {
    return new Promise<any>((resolve, reject) => {
      this.http.get<any>(`${environment.apiUrlGo}/getSchoolInfo`).toPromise()
        .then(res => {
          localStorage.setItem(environment.SchoolInFo, JSON.stringify(res));
          resolve(res);
        }, err => reject(err));
    });
  }

  getClassRooms(opt?) {
    return new Promise<any>((resolve, reject) => {
      this.http.get<any>(`${environment.apiUrl}/getClassRooms` + (opt ? '?opt=1' : '')).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  getPersons(opt?) {
    return new Promise<any>((resolve, reject) => {
      this.http.get<any>(`${environment.apiUrl}/person/all`).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }
  findStd(data) {
    return new Promise<any>((resolve, reject) => {
      this.http.post<any>(`${environment.apiUrl}/student/search`, data).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  getStudentsNotify(data) {
    return new Promise<any>((resolve, reject) => {
      this.http.post<any>(`${environment.apiUrl}/student/getStudentsNotify`, data).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  getParentNotify(data) {
    return new Promise<any>((resolve, reject) => {
      this.http.post<any>(`${environment.apiUrl}/student/getParentNotify`, data).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }


  getInitForm() {
    return new Promise<any>((resolve, reject) => {
      this.http.get<any>(`${environment.apiUrl}/getInitForm`).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }
  getInitFormPerson() {
    return new Promise<any>((resolve, reject) => {
      this.http.get<any>(`${environment.apiUrl}/getInitFormPerson`).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }
  getAmp(province) {
    return new Promise<any>((resolve, reject) => {
      this.http.get<any>(`${environment.apiUrl}/getAmp?PROVINCE_ID=${province}`).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  getDistrict(amper) {
    return new Promise<any>((resolve, reject) => {
      this.http.get<any>(`${environment.apiUrl}/getDistrict?AMPHUR_ID=${amper}`).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  getDashboard(con?, per?) {
    if (con != null) {
      return new Promise<any>((resolve, reject) => {
        this.http.get<any>(`${environment.apiUrl}/dataDashboard?Consult=${con}&PersonNo=${per}`).toPromise()
          .then(res => {
            resolve(res);
          }, err => reject(err));
      });
    } else {
      return new Promise<any>((resolve, reject) => {
        this.http.get<any>(`${environment.apiUrl}/dataDashboard`).toPromise()
          .then(res => {
            resolve(res);
          }, err => reject(err));
      });
    }

  }
  getLeaveTypes() {

    return new Promise<any>((resolve, reject) => {
      this.http.get<any>(`${environment.apiUrl}/getLeaveType`).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });

  }

  getDataFillReport() {
    return new Promise<any>((resolve, reject) => {
      this.http.get<any>(`${environment.apiUrl}/report/getDataFill`).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  getDataFillReportPerson() {
    return new Promise<any>((resolve, reject) => {
      this.http.get<any>(`${environment.apiUrl}/report/getDataFillPerson`).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  getThaiAddress() {
    return new Promise<any>((resolve, reject) => {
      this.http.get<any>(`assets/data/thaiAddress.json`).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  loadPermission() {
    return new Promise<any>((resolve, reject) => {
      this.http.get<any>(`${environment.apiUrl}/init/permission`).toPromise()
        .then(res => {
          localStorage.setItem(environment.permission, JSON.stringify(res));
          resolve(res);
        }, err => reject(err));
    });
  }



  saveSchoolInfo(school) {
    return new Promise<any>((resolve, reject) => {
      this.http.post<any>(`${environment.apiUrl}/saveSchoolInfo`, school).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }
  saveConfig(config) {
    return new Promise<any>((resolve, reject) => {
      this.http.post<any>(`${environment.apiUrl}/saveConfig`, config).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  //vote
  // findScanCard(cardStd) {
  //   return new Promise<any>((resolve, reject) => {
  //     this.http.get<any>(`${environment.apiUrl}/votestudent/findScanCard?cardStd=${cardStd}`).toPromise()
  //       .then(res => {
  //         resolve(res);
  //       }, err => reject(err));
  //   });
  // }

  getSettingMenu() {
    return new Promise<any>((resolve, reject) => {
      this.http.get<any>(`${environment.apiUrl}/sys/menus/CloseOpen`).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  saveSettingMenu(data) {
    return new Promise<any>((resolve, reject) => {
      this.http.post<any>(`${environment.apiUrl}/sys/menus/seveCloseOpen`, data).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  checkOpenSystem() {
    return new Promise<any>((resolve, reject) => {
      this.http.get<any>(`${environment.apiUrl}/checkOpenSystem`).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  TimeCheckRow() {
    return new Promise<any>((resolve, reject) => {
      this.http.get<any>(`${environment.apiUrl}/sys/TimeCheckRow`).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  saveSettingTimeCheckRow(user): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${environment.apiUrl}/sys/saveSettingTimeCheckRow`, user)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  removeSettingTimeCheckRow(user): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${environment.apiUrl}/sys/removeSettingTimeCheckRow`, user)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  getConfirmOutSchool(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${environment.apiUrl}/goverment/getOutSchoolConfirm`)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }


  ConfirmOutSchool(data): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${environment.apiUrl}/goverment/ConfirmOutSchool`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  removeOutschoolByGov(data): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${environment.apiUrl}/goverment/removeOutschoolByGov`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  getPermission(user) {
    return new Promise<any>((resolve, reject) => {
      this.http.get<any>(`${environment.apiUrl}/getPermissionHome?PersonNo=${user}`).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  getStudentAddress(data): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${environment.apiUrl}/student/getStudentAddress`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  getConfirmOnlyDocument(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${environment.apiUrl}/goverment/getConfirmOnlyDocument`)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

  ConfirmConduct(data): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${environment.apiUrl}/goverment/ConfirmConductByStd`, data)
        .subscribe((response: any) => {
          resolve(response);
        }, reject);
    });
  }

}
